import { Heading } from "@jobber/components/Heading";
import React, { useEffect, useState } from "react";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import Locker from "./components/Locker";
import QuickBooks from "./components/QuickBooks";
import AccessControl from "./components/AccessControl";
import Jobber from "./components/Jobber";
import { useLocation, useNavigate } from 'react-router-dom';
import { Icon } from "@jobber/components/Icon";
import { FaLink } from 'react-icons/fa';

function Settings() {
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const param = queryParams.get('tab');
  const [tab, setTab] = useState(param || 'locker');
  useEffect(() => {
    document.body.classList.add("body-pd");
  }, []);
  useEffect(() => {
    setTab(param || 'locker');
  }, [param]);

  return (
    <div>
      <div className="d-flex mb-4 justify-content-between align-items-center">
        <Heading level={1}>Settings</Heading>
      </div>
      <Tabs
        id="settings"
        activeKey={tab}
        onSelect={(k) => {
          setTab(k);
          navigate(`/settings?tab=${k}`, { replace: true });
        }}
        className="mb-3 custom-tab"
      >
        <Tab eventKey={'locker'} title={
          <div className="d-flex align-items-center gap-1">
            <Icon name="lock" />
            <Heading level={4}>
              Locker
            </Heading>
          </div>
        }>
          <Locker />
        </Tab>
        <Tab eventKey={'quickbooks'} title={
          <div className="d-flex align-items-center gap-1">
            <Icon name="quickbooks" />
            <Heading level={4}>
              Quickbooks
            </Heading>
          </div>
        }>
          <QuickBooks />
        </Tab>
        <Tab eventKey={'jobber'} title={
          <div className="d-flex align-items-center gap-1">
            <FaLink />
            <Heading level={4}>
              Jobber
            </Heading>
          </div>
        }>
          <Jobber />
        </Tab>
        <Tab eventKey={'access-control'} title={
          <div className="d-flex align-items-center gap-1">
            <Icon name="lock" />
            <Heading level={4}>
              Access Control
            </Heading>
          </div>
        }>
          <AccessControl />
        </Tab>
      </Tabs>
    </div>
  );
}

export default Settings;
